module.exports = __webpack_public_path__ + "static/media/infographic_bg.e6e1abec.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/infographic_bg.png
 ** module id = 455
 ** module chunks = 0
 **/